export const isLoadedSelector = state => state.loading.isLoaded;
export const isLoadingSelector = state => !state.loading.isLoaded && !state.loading.isError;
export const isFetchingSelector = state => state.loading.isFetching;
export const isErrorSelector = state => state.loading.isError;